
TPS.PromotionMap = {
    map: null,
    markers: [],
    markerCluster: null,
    locations: null,
    openInfoWindow: null,
    autocomplete: null,
    geocoder: null,
    isLoading: true,
    isSearching: false,
    nearbyRetailers: [],
    icons: {
        dealer: 'https://aplanbyvolvo.azureedge.net/media/av/media/aplan/map-markers/mapmarker_dealer_50x50_bk.png',
        home: 'https://aplanbyvolvo.azureedge.net/media/av/media/aplan/map-markers/mapmarker_home_50x50.png',
    },
    clusterSettings: {
        gridSize: 10,
        maxZoom: 15,
        imagePath: 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m'
    },
    labels: {
        location: {
            city: 'City',
            state: 'State',
            phone: 'Phone',
            city: 'City',
            directionsbtn: 'Get Directions',
            directionsbtnTitle: 'Get Directions to'
        },
        results: {
            msg: 'There are {{total}} within {{dist}} from',
            clear: 'Clear Search Results'
        }
    },
    culture: 'en-US',
    init: function (formSelector, mapSelector, nodeGuid, labels) {

        if (!mapSelector && !nodeGuid)
            return;

        var _this = TPS.PromotionMap;

        TPS.Util.loadWebserviceJS('CMSApp.AV.API.Promotion');

        var _mapElem = document.getElementById(mapSelector);

        _this.map = new google.maps.Map(_mapElem, {
            center: { lat: 40.749933, lng: -73.98633 },
            zoom: 15,
            minZoom: 3,
            maxZoom: 20
        });

        _this.getParticipatingLocations(nodeGuid);

        if (typeof labels === 'object') {
            _this.labels = labels;
        }

        if (formSelector)
            _this.setupAutocomplete(formSelector)

    },
    getParticipatingLocations: function (nodeGuid) {
        var _this = TPS.PromotionMap;
        _this.culture = document.getElementById('lng').value;
        CMSApp.AV.API.Promotion.GetPromotionPartners(
            nodeGuid,
            _this.culture,
            function (d) {
                _this.locations = d;
                _this.createMapMarkers();
            },
            function (d) {
                console.error(d);
            });

    },
    createMapMarkers: function () {
        var _this = TPS.PromotionMap;
        var _bounds = new google.maps.LatLngBounds();
        //
        jQuery(_this.locations).each(function (k, _item) {

            var _position = new google.maps.LatLng(_item.Latitude, _item.Longitude);

            _item.marker = new google.maps.Marker({
                position: _position,
                map: _this.map,
                icon: _this.icons.dealer,
            });

            _item.infoWindow = new google.maps.InfoWindow({
                content: _this.createMapMarkerInfo(_item)
            });

            _item.marker.addListener('click', function () {
                // if the infowindow is already open, close it
                if (_this.openInfoWindow)
                    _this.openInfoWindow.close();
                // store the current infowindow in memory
                _this.openInfoWindow = _item.infoWindow;
                _item.infoWindow.open(_this.map, _item.marker);
            });

            _this.markers.push(_item.marker);
            _bounds.extend(_position);

        });

        _this.markerCluster = new MarkerClusterer(_this.map, _this.markers, _this.clusterSettings);

        _this.centerMapAndZoom(_bounds);
    },
    createMapMarkerInfo: function (location) {
        var _this = TPS.PromotionMap;

        var _html = '<strong>' + location.Name + '</strong>';
        _html += '<br/><br/><strong>' + _this.labels.location.city + '</strong> ' + location.City;
        _html += '<br/><strong>' + _this.labels.location.state + '</strong> ' + location.State;
        _html += '<br/><strong>' + _this.labels.location.phone + '</strong> ' + location.Phone;

        return _html;

    },
    setupAutocomplete: function (searchForm) {
        var _this = TPS.PromotionMap;
        // get the country code from the culture
        var _countryCode = _this.culture.split('-')[1];

        var _autocompleteInput = document.getElementById('retailers-map-search-address');
        var _autocompleteButton = document.getElementById('retailers-map-search-submit');
        _this.geocoder = new google.maps.Geocoder();
        // setup the autocomplete input
        _this.autocomplete = new google.maps.places.Autocomplete(
            _autocompleteInput,
            {
                componentRestrictions: { country: [_countryCode] },
            }
        );

        _this.autocomplete.addListener('place_changed', function () {
            var _place = _this.autocomplete.getPlace();
            if (_place.geometry === undefined || _place.geometry === null) {
                return;
            }
        });

        _autocompleteInput.addEventListener('keydown', function (e) {
            if (e.keyCode == 13) {
                // prevent the asp form submitting
                e.preventDefault();
                // submit the search
                _this.submitMapFilters();
            }
        });

        _autocompleteButton.addEventListener('click', function () {
            _this.submitMapFilters();
        });


    },
    submitMapFilters: function (e) {
        var _this = TPS.PromotionMap;
        var _searchInput = document.getElementById('retailers-map-search-address');

        if (_searchInput.value !== '' && _searchInput.value !== null) {
            
            _this.geocoder.geocode(
                {
                    address: _searchInput.value
                },
                function (results, status) {
                    if (status === google.maps.GeocoderStatus.OK) {
                        if (results[0].geometry.bounds) {
                            _this.centerMapAndZoom(results[0].geometry.bounds);
                        }
                        if (results[0].geometry.location) {
                            _this.findNearbyLocations(results[0].geometry.location);
                        }
                    }
                }
            );
        }


    },
    findNearbyLocations: function (_locationFilter) {
        if (!_locationFilter)
            return;

        var _this = TPS.PromotionMap;
        var _area = [];

        _this.nearbyRetailers = [];

        jQuery(_this.locations).each(function (_key, _location) {

            // calculate the distance from the searched
            // address to each map marker
            var _dist = google.maps.geometry.spherical.computeDistanceBetween(_location.marker.getPosition(), _locationFilter);
            var _distUnit = 'km';
            // Convert meter to Km
            _dist = _dist / 1000;
            

            if (_this.culture === 'en-US') {
                // Convert Km to Miles if USA culture
                _dist = _dist / 1.60934;
                _distUnit = 'miles';
            }

            _location['Distance'] = Math.round(_dist);
            _location['DistanceUnit'] = _distUnit;

            // add a retailer to the list if
            // it is within 100 km/miles of the searched address
            if (_dist <= 100) {
                _area.push(_location);
            }

        });
        // sort the retailers by distance
        _area.sort(function (a, b) {
            return a.Distance - b.Distance;
        });

        _this.nearbyRetailers = [ ..._area ];
        // render the list of retailers
        _this.renderNearbyRetailers();
    },
    renderNearbyRetailers: function () {
        var _this = TPS.PromotionMap;
        var _target = jQuery('.retailers-map-list');
        var _bounds = new google.maps.LatLngBounds();

        // clear the list wrappe element
        _target.empty();

        jQuery(_this.nearbyRetailers).each(function (_k, _item) {
            var _position = new google.maps.LatLng(_item.Latitude, _item.Longitude);
            _bounds.extend(_position);
            // append the retailer to the list
            _target.append(_this.createNearbyRetailerItem(_item));

        });
        // reset the map to show
        // the nearby retailers only
        _this.centerMapAndZoom(_bounds);
        _this.addResultsMessage();
    },
    createNearbyRetailerItem: function (_item) {
        var _this = TPS.PromotionMap;

        var _html;

        _html = '<div class="participating-dealer-list-item promotion-dealer-list-item" tabindex="0" onclick="TPS.PromotionMap.centerOnRetailer(' + _item.Latitude + ',' + _item.Longitude +'); return false;">';
        _html += '<div class="participating-dealer-list-item-name">' + _item.Name  + '</div>';
        _html += '  <div class="participating-dealer-list-item-info">';
        _html += '      <address class="participating-dealer-list-item-address">';
        _html += '          ' + _this.getRetailerAddressString(_item) + ' ' + '<br/>' + _item.Phone;
        _html += '      </address>';
        _html += '      <div class="participating-dealer-list-item-dist">' + _item.Distance + _item.DistanceUnit + '</div>';
        _html += '  </div>';
        _html += '<a href="https://www.google.com/maps/search/?api=1&amp;query=' + _this.getRetailerAddressString(_item) + '" target="_blank" title="' + _this.labels.location.directionsbtnTitle + ' ' + _item.Name + '" >' + _this.labels.location.directionsbtn + '</a>';
        _html += '</div>';

        return _html;


    },
    getRetailerAddressString(_item) {
        var _string = '';
        _string += _item.Address ? _item.Address + ', ' : '';
        _string += _item.City ? _item.City + ', ' : '';
        _string += _item.State ? _item.State + ', ' : '';
        _string += _item.Zipcode ? _item.Zipcode : '';

        return _string;
    },
    centerMapAndZoom: function (_bounds) {
        var _this = TPS.PromotionMap;
        _this.map.fitBounds(_bounds);
        _this.map.panToBounds(_bounds);
    },
    clearAddressSearch: function () {

        var _this = TPS.PromotionMap;

        var _form = jQuery('#retailers-map-search');
        _form.find('.retailers-map-results-msg').remove();
        _form.find('#retailers-map-search-address').val('');
        jQuery('.retailers-map-list').empty();

        _this.nearbyRetailers = [];

        _this.resetBounds();

    },
    addResultsMessage: function () {
        var _this = TPS.PromotionMap;
        var _form, _msg, _msg_txt, _dist;

        _dist = _this.culture === 'en-US' ? '100 miles' : '100 km';

        _msg_txt = _this.labels.results.msg.replace('{{total}}', _this.nearbyRetailers.length).replace('{{dist}}', _dist) + ' ' + jQuery('#retailers-map-search-address').val();


        _form = jQuery('#retailers-map-search');
        _form.find('.retailers-map-results-msg').remove();

        _msg = '<div class="retailers-map-results-msg row column">';
        _msg += '<div class="retailers-map-results-msg-txt">' + _msg_txt + '</div>';
        _msg += '<a  class="retailers-map-results-msg-action" href="#" onclick="TPS.PromotionMap.clearAddressSearch(); return false;">' + _this.labels.results.clear + '</a>';
        _msg += '</div>';

        _form.append(_msg);

    },
    resetBounds: function () {
        var _this = TPS.PromotionMap;
        var _bounds = new google.maps.LatLngBounds();

        jQuery(_this.locations).each(function (_k, _item) {
            var _position = new google.maps.LatLng(_item.Latitude, _item.Longitude);
            _bounds.extend(_position);
        });

        _this.centerMapAndZoom(_bounds);
    },
    centerOnRetailer: function (_lat, _lng) {
        var _bounds = new google.maps.LatLngBounds();
        var _position = new google.maps.LatLng(_lat, _lng);
        _bounds.extend(_position);
        _this.centerMapAndZoom(_bounds);
    }
}
;
